import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { backArrow } from '../../../../assets/images'
import { message } from "antd";
import { dsButtonLink, dsButtonPrimary, joinButtonClasses } from '../../../../utils/buttonStyles';

function BackupCodes({codeHandler, back_codes, login_button = false}) {
  const [clip, setClip] = useState(true)
  const history = useHistory();
  
  const renderCodes = () => {
    return (
      <div className="grid grid-cols-2 gap-2 w-3/4 justify-items-end">
        {back_codes?.map((code, index) => (
          <div key={index} className='text-base text-grey-600 mt-3'>
            {code}
          </div>
        ))}
      </div>
    );
  }

  const handleCopyClick = () => {
    setClip(false)
    navigator.clipboard.writeText(back_codes?.join(', '));
    setTimeout(() => { setClip(true) }, 2000);
    message.success("Back-up codes copied!")
  };

  return (
    <div className='my-12 px-4'>
      <h1 className='font-fig-extrabold text-xl font-medium leading-8 text-gray-900'>Multi-Factor Authentication </h1>
      <div className='font-fig-extrabold text-lg font-medium leading-8 text-gray-900 mt-2'>Back-up Codes</div>
      <p className='text-base text-gray-600 mt-3 mr-20 mb-0 w-96'>
        keep this backup codes safe incase you lose access to the authenticator app
      </p>
      <div className=' bg-gray-100 p-4 mx-8 shadow-inner mt-6 w-96 border-2 rounded-lg'>
        <p
          onClick={handleCopyClick}
          className={joinButtonClasses(dsButtonLink, 'mb-0 float-right w-max text-gray-600 hover:text-blue-800')}
        >
          {clip ? 'copy' : 'copied!'}
        </p>
        {renderCodes()}
      </div>
      <p
        className='mb-0 mt-8 mx-6 text-gray-500 text-base  w-max border-white border-b'
      >
        Multi-factor authentication has been set-up successfully
      </p>
      {login_button && (
        <button
          onClick={() => { sessionStorage.clear(); history.push('/login') }}
          title='login'
          className={joinButtonClasses(dsButtonPrimary, 'mb-0 ml-8 mt-6 h-12 w-96')}
        >
          Proceed to Login
        </button>
      )}
    </div>
  )
}

BackupCodes.propTypes = {}

export default BackupCodes
